module.exports = __webpack_public_path__ + "static/media/roulette.7d45af2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/games/roulette.png
// module id = 2405
// module chunks = 7